export default __webpack_public_path__ + "static/media/news4.e6ad0da0.webp";